// extracted by mini-css-extract-plugin
module.exports = {"upload":"FileUploadDragger_upload__3C164"};